import { Controller } from "@hotwired/stimulus";

const EXCEPTED_FROM_WORKING_LIMITATION = "EXCEPTUADA_DE_LIMITACION";

export default class extends Controller {
  static targets = [
    "homeRegion", "homeCommune",
    "originRegion", "originCommune",
    "workRegion", "workCommune",
    "installationType", "principalRutWrapper", "estRutWrapper",
    "distributionSystem", "optionalWhenExcepted"
  ];

  static values = {
    regions: Object
  };

  connect() {
    this.syncAllCommunes();
    this.toggleInstallationRut();
    this.toggleWorkingFieldsRequired();
  }

  updateCommunes(event) {
    const regionSelect = event.currentTarget;
    const communeTargetName = regionSelect.dataset.communeTarget;
    const communeSelect = this[`${communeTargetName}Target`];
    this.setCommuneOptions(regionSelect.value, communeSelect);
  }

  toggleInstallationRut() {
    if (!this.hasInstallationTypeTarget) return;

    const installationType = this.installationTypeTarget.value;
    const showEst = installationType === "INSTALACIONES_EMPRESA_USUARIA_EST";
    const showPrincipal = installationType === "INSTALACIONES_EMPRESA_PRINCIPAL_SUBCONTRATACION";

    this.estRutWrapperTarget.classList.toggle("d-none", !showEst);
    this.principalRutWrapperTarget.classList.toggle("d-none", !showPrincipal);
  }

  toggleWorkingFieldsRequired() {
    if (!this.hasDistributionSystemTarget) return;

    const isExcepted = this.distributionSystemTarget.value === EXCEPTED_FROM_WORKING_LIMITATION;
    const isRequired = !isExcepted;

    this.optionalWhenExceptedTargets.forEach((field) => {
      const formGroup = field.closest(".mb-3") || field.closest(".form-group");
      const label = formGroup?.querySelector("label");

      if (label) {
        label.classList.toggle("required", isRequired);
      }

      field.required = isRequired;
      if (isRequired) {
        field.setAttribute("required", "required");
      } else {
        field.removeAttribute("required");
      }

      if (field.type === "number") {
        if (isExcepted) {
          field.removeAttribute("min");
        } else {
          field.setAttribute("min", "1");
        }
      }
    });
  }

  syncAllCommunes() {
    this.setCommuneOptions(this.homeRegionTarget.value, this.homeCommuneTarget);
    this.setCommuneOptions(this.originRegionTarget.value, this.originCommuneTarget);
    this.setCommuneOptions(this.workRegionTarget.value, this.workCommuneTarget);
  }

  setCommuneOptions(regionCode, communeSelect) {
    if (!communeSelect) return;

    const selectedCommune = communeSelect.value;
    const communes = this.regionsValue[regionCode] || [];
    const fragment = document.createDocumentFragment();

    fragment.appendChild(new Option("Seleccione una comuna", ""));

    communes.forEach((commune) => {
      fragment.appendChild(new Option(commune, commune, false, selectedCommune === commune));
    });

    communeSelect.replaceChildren(fragment);
  }
}
